export class OrganizationConfig {
    alias: string | null;
    orgGroups: Array<string> | null;
}